import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
  QuestionOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Spin,
  Tooltip,
} from "antd";
import React from "react";
import { useLocation } from "react-router-dom";
import { dayjs } from "../../../Utilities/dayjs";
import ItemsService from "../../Services/ItemsService";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/PageRoute";
import { useTheme } from "../../Context/ThemeContext";

const SelectBatchItemModal: React.FC<{
  open: boolean;
  onCancel: any;
  inputFieldNull: () => void;
  id: string | undefined;
  setBatchData: (param: any) => void;
  setBatchItmName: (param: any) => void;
  setForAddBatchData: (param: any) => void;
  alReadySelectedData: any;
  setBatchQty: (param: any) => void;
  batchQty: any;
  totalQty: any;
  forAddBatchData: any;
  selectedBatchData: any;
  setSelectedBatchData: (param: any) => void;
  setTriggerBatchData: (param: any) => void;
  setAddBatches: (param: any) => void;

  addBatches: any;
}> = (props) => {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();

  const location = useLocation();
  const { currentClient } = useClient();
  const [batchData, setBatchData] = React.useState<any[]>([]);
  const [data, setData] = React.useState<any[]>([]);
  const [formTwoData, setFormTwoData] = React.useState<any[]>([]);
  const [itmName, setItmName] = React.useState<any>();
  const { openNotification } = React.useContext(notificationContext);
  const [searchVal, setSearchVal] = React.useState<any>();
  const [purchasePrice, setPurchasePrice] = React.useState<any>();
  const [addBatchNo, setAddBatchNo] = React.useState<any[]>([]);
  const [btnLoading, setBtnLoading] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);

      const res = await ItemsService.getItem(currentClient?.id, props?.id);
      if (res?.result) {
        const matchItems = res.result.inventoryItem?.batchItem || [];
        debugger;
        setBatchData(matchItems ?? props?.selectedBatchData?.batchItem);
        setItmName(res.result.inventoryItem?.name);
        console.log("itm", matchItems);
        setLoading(false);
        if (matchItems && matchItems.length > 0) {
        }
      } else {
        setLoading(false);
      }
    };

    getData();
  }, [currentClient?.id, props?.id, form]);

  const handleChange = (changedValues: any, allValues: any) => {
    const batches = allValues?.batches ?? [];
    setData(batches);
    console.log("data", batches);
  };
  const secFormVal = (changedValues: any, allValues: any) => {
    const batches2 = (allValues?.batches2 ?? []).map((item: any) => ({
      ...item,
      type: 1,
      itemAddType: 1,
    }));
    form2.setFieldsValue({ batches2 });
    setFormTwoData(batches2);
  };

  console.log("formTwoData", props);

  React.useEffect(() => {
    const margeSecFormData = [
      ...formTwoData,
      ...(props?.forAddBatchData ?? []),
    ];
    setAddBatchNo(props?.addBatches ?? margeSecFormData);
  }, []);

  const margeData = [...data, ...(props?.batchQty ?? [])];
  const updateMergeData = margeData.filter((itm: any) => itm !== undefined);
  const selectedData = [
    ...(props?.selectedBatchData?.batchItem?.[0]?.itemAddType === 1 &&
    data?.length === 0
      ? props?.selectedBatchData?.batchItem
      : []),
    ...(formTwoData ?? []),
  ];

  const saveData = () => {
    form
      .validateFields()
      .then(() => form2.validateFields())
      .then(() => {
        props?.setBatchItmName(itmName);
        props?.setSelectedBatchData([]);
        props?.setBatchData(
          data?.length
            ? data
            : props?.selectedBatchData?.batchItem?.[0]?.itemAddType !== 1
            ? props?.selectedBatchData?.batchItem
            : []
        );
        props?.setForAddBatchData(selectedData || props?.forAddBatchData);
        props?.setBatchQty(updateMergeData);
        props?.setAddBatches(addBatchNo);
        props?.onCancel(false);
        props?.setTriggerBatchData((x: boolean) => !x);
      })
      .catch((error) => {
        console.error("Validation failed:", error);
      });
  };

  console.log("selectedBatchData", props?.selectedBatchData);
  React.useEffect(() => {}, [form, props?.totalQty]);

  console.log("batchData", batchData);
  // const check = batchData?.some(
  //   (d: any) =>
  //     d.batchNumber === props?.selectedBatchData?.batchItem?.[0]?.batchNumber &&
  //     props?.selectedBatchData?.batchItem?.[0]?.itemAddType === 1
  // );
  const check = props?.selectedBatchData?.name === itmName;
  React.useEffect(() => {
    if (
      (check && props?.selectedBatchData?.batchItem) ||
      props?.alReadySelectedData?.batchItem?.[0]?.itemAddType === 1
    ) {
      const dataa =
        props?.alReadySelectedData?.batchItem?.length ||
        // props?.selectedBatchData?.batchItem?.length ||
        props?.alReadySelectedData?.batchItem?.[0]?.itemAddType === 1
          ? props?.alReadySelectedData
          : props?.selectedBatchData;

      const isBatchValid = batchData.some(
        (batchItem) =>
          batchItem.batchNumber === dataa?.batchItem?.[0]?.batchNumber
      );

      console.log("isBatchValid", isBatchValid);
      if (
        isBatchValid ||
        props?.alReadySelectedData?.batchItem?.[0]?.itemAddType === 1 ||
        props?.selectedBatchData?.batchItem?.length
      ) {
        form.setFieldsValue({
          batches: [
            {
              batchNumber: dataa?.batchItem?.[0]?.batchNumber || "",
              mfDate: dataa?.batchItem?.[0]?.mfDate
                ? dayjs(dataa?.batchItem?.[0]?.mfDate)
                : undefined,
              expiryDate: dataa?.batchItem?.[0]?.expiryDate
                ? dayjs(dataa?.batchItem?.[0]?.expiryDate)
                : undefined,
              qty: dataa?.batchItem?.[0]?.qty ?? 0,
              purchasePrice: dataa?.batchItem?.[0]?.purchasePrice ?? 0,
              salesPrice: dataa?.batchItem?.[0]?.salesPrice ?? 0,
              currentQty: dataa?.batchItem?.[0]?.currentQty ?? 0,
              id: dataa?.batchItem?.[0]?.id,
            },
            {},
          ],
        });
      }
    }
  }, [props?.alReadySelectedData, props?.selectedBatchData, batchData]);

  console.log("addBatchNo0oo", addBatchNo);

  const handleAddBatchNumber = async () => {
    form3.validateFields().then(() => {
      setBtnLoading(true);
      if (!searchVal) {
        openNotification("error", "Please enter a Batch No.");
        setBtnLoading(false);
        return;
      }
      if (!purchasePrice) {
        openNotification("error", "Please enter a Purchase price.");
        setBtnLoading(false);

        return;
      }

      const allBatchNumbers = [...(addBatchNo || [])];

      console.log("allBatchNumbers", allBatchNumbers, searchVal);

      if (
        allBatchNumbers.some(
          (item) =>
            item.batchNumber === searchVal &&
            item.purchasePrice === purchasePrice
        )
      ) {
        openNotification(
          "error",
          "Same Batch No and Name already exist with a different Purchase Price"
        );
        setBtnLoading(false);

        return;
      }

      if (
        batchData.some(
          (item) =>
            item.batchNumber === searchVal &&
            item.purchasePrice == purchasePrice
        )
      ) {
        openNotification(
          "error",
          "Same Batch No and Name already exist with a different Purchase Price"
        );
        setBtnLoading(false);

        return;
      }

      const newEntry = {
        batchNumber: searchVal,
        mfDate: undefined,
        expiryDate: undefined,
        qty: 0,
        salesPrice: 0,
        purchasePrice: purchasePrice,
      };

      const existingList = form2.getFieldValue("batches2") || [];
      const updatedList = [...existingList, newEntry];

      setFormTwoData((prev) => [...prev, newEntry]);

      setAddBatchNo((prev: any) => {
        const merged = [...prev, newEntry];
        return merged;
      });

      form2.setFieldsValue({
        batches2: updatedList.map((d) => ({
          batchNumber: d?.batchNumber || "",
          mfDate: d?.mfDate || undefined,
          expiryDate: d?.expiryDate ? dayjs(d?.expiryDate) : undefined,
          qty: d?.qty,
          salesPrice: d?.salesPrice,
          purchasePrice: d?.purchasePrice,
        })),
      });
      setBtnLoading(false);
      setSearchVal("");
      form3.setFieldsValue({
        pPrice: "",
      });
    });
  };

  const handleDeleteBatch = (index: number) => {
    const existingList = form2.getFieldValue("batches2") || [];

    if (index < 0 || index >= existingList.length) return;

    const updatedList = existingList.filter((_: any, i: number) => i !== index);

    form2.setFieldsValue({
      batches2: updatedList.map((d: any) => ({
        batchNumber: d?.batchNumber || "",
        mfDate: d?.mfDate || undefined,
        expiryDate: d?.expiryDate ? dayjs(d?.expiryDate) : undefined,
        qty: d?.qty,
        salesPrice: d?.salesPrice,
        purchasePrice: d?.purchasePrice,
      })),
    });
    setFormTwoData(updatedList);
    setAddBatchNo(updatedList);
  };

  const text = (
    <span>
      Here sales price is optional, you can update the same on item update
    </span>
  );

  return (
    <>
      <Modal
        width={1200}
        // onCancel={() => props?.onCancel(false)}
        closable={false}
        open={props?.open}
        maskClosable={false}
        title={`${
          props?.alReadySelectedData?.batchItem?.length ? "Selected" : "Select"
        } Batch Item`}
        footer={
          <>
            <Row justify={"end"} gutter={10}>
              <Col>
                <Button
                  disabled={loading ? true : false}
                  type="primary"
                  onClick={() => {
                    saveData();
                  }}
                >
                  Save
                </Button>
              </Col>
              <Col>
                {props?.selectedBatchData?.batchItem ? (
                  <>
                    <Button
                      disabled={loading ? true : false}
                      onClick={() => {
                        props?.setSelectedBatchData([]);
                        props?.setBatchData(
                          data?.length
                            ? data
                            : props?.selectedBatchData?.batchItem?.[0]
                                ?.itemAddType !== 1
                            ? props?.selectedBatchData?.batchItem
                            : []
                        );
                        if (props?.selectedBatchData) {
                          props?.setBatchItmName(
                            check ? itmName : props?.selectedBatchData?.name
                          );
                        } else {
                          props?.setBatchItmName(itmName);
                        }
                        if (
                          props?.selectedBatchData?.batchItem?.[0]
                            ?.itemAddType === 1
                        ) {
                          props?.setForAddBatchData(
                            selectedData || props?.forAddBatchData
                          );
                        } else {
                          // props?.setBatchData(
                          //   data?.length
                          //     ? data
                          //     : props?.selectedBatchData?.batchItem?.[0]
                          //         ?.itemAddType !== 1
                          //     ? props?.selectedBatchData?.batchItem
                          //     : []
                          // );
                        }
                        props?.setTriggerBatchData((x: boolean) => !x);
                        // props?.inputFieldNull();
                        props?.onCancel(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </>
                ) : props?.alReadySelectedData?.batchItem?.length ? (
                  <>
                    <Button
                      disabled={loading ? true : false}
                      onClick={() => {
                        // props?.setSelectedBatchData([]);
                        if (props?.selectedBatchData) {
                          props?.setBatchItmName(
                            check ? itmName : props?.selectedBatchData?.name
                          );
                        } else {
                          props?.setBatchItmName(itmName);
                        }
                        if (
                          props?.selectedBatchData?.batchItem?.[0]
                            ?.itemAddType === 1
                        ) {
                          props?.setForAddBatchData(
                            props?.selectedBatchData?.batchItem
                          );
                        } else {
                          props?.setBatchData(
                            props?.selectedBatchData?.batchItem
                          );
                        }
                        props?.setTriggerBatchData((x: boolean) => !x);
                        // props?.inputFieldNull();
                        props?.onCancel(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </>
                ) : (
                  <Button
                    onClick={() => {
                      props?.inputFieldNull();
                      props?.onCancel(false);
                    }}
                  >
                    Cancel
                  </Button>
                )}
              </Col>
            </Row>
          </>
        }
      >
        <Spin indicator={<LoadingOutlined />} spinning={loading}>
          <Form
            form={form}
            initialValues={{
              batches: [{}],
            }}
            onValuesChange={handleChange}
          >
            <table className="AddPageTabelDesign" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Select Batch No.</th>
                  <th>Mfg. Date</th>
                  <th>Expiry Date</th>

                  <th>Available Qty.</th>
                  <th>Quantity</th>

                  <th>Purchase Price</th>

                  <th>Sales Price </th>

                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                <Form.List name="batches">
                  {(fields, { add, remove }, index) => (
                    <>
                      {fields.map((field, name, index) => (
                        <tr key={field.key}>
                          <td style={{ width: "15%" }}>
                            <Form.Item
                              name={[name, "batchNumber"]}
                              className="m-0"
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const openingQty = getFieldValue([
                                      "batches",
                                      name,
                                      "openingQuantity",
                                    ]);
                                    if (openingQty && !value) {
                                      return Promise.reject(
                                        new Error(
                                          "Batch No. is required if Opening Qty is entered"
                                        )
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                }),
                                {
                                  required: formTwoData?.length
                                    ? false
                                    : name === fields.length - 1 &&
                                      fields.length !== 1
                                    ? false
                                    : true,
                                  message: "Please input your Batch Number!",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Batch No."
                                disabled={
                                  props?.alReadySelectedData?.batchItem?.length
                                    ? true
                                    : false
                                }
                                options={batchData
                                  ?.filter(
                                    (bData) =>
                                      !fields.some(
                                        (f, i) =>
                                          i !== name &&
                                          form.getFieldValue([
                                            "batches",
                                            i,
                                            "batchNumber",
                                          ]) === bData.batchNumber
                                      )
                                  )
                                  .map((batchItem) => ({
                                    value: batchItem.batchNumber,
                                    key: batchItem?.id,
                                    label: (
                                      <>
                                        <span style={{ fontWeight: "bold" }}>
                                          {batchItem?.batchNumber}
                                        </span>
                                        <br />
                                        {batchItem?.currentQty}
                                      </>
                                    ),
                                    title: batchItem.batchNumber,
                                  }))}
                                onChange={(value) => {
                                  const selectedBatch = batchData?.find(
                                    (batchItem) =>
                                      batchItem?.batchNumber === value
                                  );

                                  if (selectedBatch) {
                                    form.setFields([
                                      {
                                        name: ["batches", name, "batchNumber"],
                                        value: value,
                                      },
                                      {
                                        name: ["batches", name, "id"],
                                        value: selectedBatch.id,
                                      },
                                      {
                                        name: ["batches", name, "mfDate"],
                                        value: dayjs(selectedBatch?.mfDate),
                                      },
                                      {
                                        name: ["batches", name, "expiryDate"],
                                        value: dayjs(selectedBatch?.expiryDate),
                                      },
                                      {
                                        name: [
                                          "batches",
                                          name,
                                          "openingQuantity",
                                        ],
                                        value:
                                          location.pathname.split("/")[4] !==
                                            "sales" &&
                                          location.pathname.split("/")[4] !==
                                            "purchase"
                                            ? selectedBatch.openingQuantity
                                            : undefined,
                                      },
                                      {
                                        name: ["batches", name, "currentQty"],
                                        value:
                                          location.pathname.split("/")[4] ===
                                            "sales" ||
                                          location.pathname.split("/")[4] ===
                                            "purchase"
                                            ? selectedBatch.availableQty
                                            : undefined,
                                      },
                                      {
                                        name: ["batches", name, "salesPrice"],
                                        value: selectedBatch.salesPrice,
                                      },
                                      {
                                        name: [
                                          "batches",
                                          name,
                                          "purchasePrice",
                                        ],
                                        value: selectedBatch.purchasePrice,
                                      },
                                    ]);

                                    if (
                                      !form.getFieldValue([
                                        "batches",
                                        name,
                                        "added",
                                      ])
                                    ) {
                                      add();
                                      form.setFieldValue(
                                        ["batches", name, "added"],
                                        true
                                      );
                                    }
                                  }
                                }}
                              />
                            </Form.Item>
                          </td>
                          <td style={{ width: "10%" }}>
                            <Form.Item name={[name, "mfDate"]} className="m-0">
                              <DatePicker
                                placeholder="Mfg. Date"
                                format={"DD/MM/YYYY"}
                                style={{ width: "100%" }}
                                disabled={
                                  form?.getFieldValue(["batches", name])?.id ===
                                  undefined
                                    ? false
                                    : true
                                }
                              />
                            </Form.Item>
                          </td>
                          <td style={{ width: "10%" }}>
                            <Form.Item
                              name={[name, "expiryDate"]}
                              className="m-0"
                            >
                              <DatePicker
                                placeholder="Expiry Date"
                                format="DD/MM/YYYY"
                                style={{ width: "100%" }}
                                disabled={
                                  form?.getFieldValue(["batches", name])?.id ===
                                  undefined
                                    ? false
                                    : true
                                }
                              />
                            </Form.Item>
                          </td>

                          <td style={{ width: "10%" }}>
                            <Form.Item
                              name={[name, "currentQty"]}
                              className="m-0"
                            >
                              <InputNumber
                                min={0}
                                disabled={true}
                                placeholder="Available Qty."
                                style={{ width: "100%" }}
                                controls={false}
                              />
                            </Form.Item>
                          </td>
                          <td style={{ width: "10%" }}>
                            <Form.Item
                              name={[name, "qty"]}
                              className="m-0"
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    const currentQty =
                                      getFieldValue([
                                        "batches",
                                        name,
                                        "currentQty",
                                      ]) || 0;

                                    console.log(`currentQty:`, currentQty);
                                    const currentBatchId = getFieldValue([
                                      "batches",
                                      name,
                                      "id",
                                    ]);
                                    const currentBatchNumber = getFieldValue([
                                      "batches",
                                      name,
                                      "batchNumber",
                                    ]);
                                    console.log("totalQty", props?.totalQty);

                                    const matchedBatch = props?.totalQty?.find(
                                      (batchItem: any) =>
                                        (batchItem.id === currentBatchId &&
                                          batchItem.batchNumber ===
                                            currentBatchNumber) ||
                                        props?.selectedBatchData?.batchItem

                                          ?.map((b: any) => b.id)
                                          .includes(batchItem.id) ||
                                        props?.selectedBatchData?.batchItem

                                          ?.map((b: any) => b.batchNumber)
                                          .includes(batchItem.batchNumber)
                                    );

                                    // const matchedBatch = props?.totalQty?.find(
                                    //   (batchitem: any) =>
                                    //     batchitem.id === currentBatchId &&
                                    //     batchitem.batchNumber === currentBatchNumber
                                    // );

                                    console.log(
                                      "currentBatchId",
                                      currentBatchId
                                    );

                                    console.log("matchedBatch", matchedBatch);

                                    const maxQty = matchedBatch?.qty
                                      ? matchedBatch?.qty + value
                                      : value;
                                    console.log(
                                      `Max qty for batchitem:`,
                                      maxQty
                                    );
                                    const finalQty =
                                      currentQty - matchedBatch?.qty;
                                    console.log("finalQty", finalQty);
                                    if (
                                      location.pathname.split("/")[4] ===
                                        "sales" &&
                                      props?.selectedBatchData?.batchItem?.[0]
                                        ?.itemAddType !== 1 &&
                                      maxQty > currentQty
                                    ) {
                                      return Promise.reject(
                                        new Error(
                                          `Max allowed qty is ${
                                            matchedBatch?.qty
                                              ? finalQty
                                              : currentQty
                                          }`
                                        )
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                }),
                                {
                                  validator: (_: any, value) =>
                                    value > 0 ||
                                    name === fields.length - 1 ||
                                    props?.selectedBatchData?.batchItem?.[0]
                                      ?.itemAddType === 1
                                      ? Promise.resolve()
                                      : Promise.reject(
                                          "Quantity must be greater than 0!"
                                        ),
                                },
                                {
                                  required:
                                    name === fields.length - 1 ? false : true,
                                  message: "Please enter quantity!",
                                },
                              ]}
                            >
                              <InputNumber
                                min={1}
                                placeholder="Qty."
                                style={{ width: "100%" }}
                                // max={props?.batchQty?.[name]}
                                maxLength={11}
                                disabled={
                                  props?.alReadySelectedData?.batchItem?.length
                                    ? true
                                    : name === fields.length - 1
                                }
                              />
                            </Form.Item>
                          </td>

                          {/* {location.pathname.split("/")[4] === "sales" ? ( */}
                          <td style={{ width: "12%" }}>
                            <Form.Item
                              name={[name, "purchasePrice"]}
                              className="m-0"
                            >
                              <InputNumber
                                min={0}
                                placeholder="Purchase Price"
                                style={{ width: "100%" }}
                                type="number"
                                controls={false}
                                maxLength={11}
                                disabled={
                                  props?.alReadySelectedData?.batchItem
                                    ?.length ??
                                  location.pathname.split("/")[4] === "sales"
                                    ? true
                                    : false
                                }
                              />
                            </Form.Item>
                          </td>

                          <td style={{ width: "10%" }}>
                            <Form.Item
                              name={[name, "salesPrice"]}
                              className="m-0"
                            >
                              <InputNumber
                                min={0}
                                placeholder="Sales Price"
                                type="number"
                                style={{ width: "100%" }}
                                controls={false}
                                disabled={
                                  form?.getFieldValue(["batches", name])?.id ===
                                  undefined
                                    ? false
                                    : true
                                }
                              />
                            </Form.Item>
                          </td>

                          {/* {location.pathname.split("/")[4] === "sales" ||
                          location.pathname.split("/")[4] === "purchase" ? (
                            <></>
                          ) : (
                            <td style={{ width: "10%" }}>
                              <Form.Item
                                name={[name, "status"]}
                                className="m-0"
                              >
                                <Select
                                  style={{ width: "100%" }}
                                  options={[
                                    {
                                      value: BatchItemStatus.Available,
                                      label: "Available",
                                    },
                                    {
                                      value: BatchItemStatus.Sold,
                                      label: "Sold",
                                    },
                                    {
                                      value: BatchItemStatus.Expired,
                                      label: "Expired",
                                    },
                                    {
                                      value: BatchItemStatus.Damaged,
                                      label: "Damaged",
                                    },
                                    {
                                      value: BatchItemStatus.Returned,
                                      label: "Returned",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </td>
                          )} */}
                          <td style={{ width: "3%" }} align="center">
                            <Button
                              onClick={() => {
                                const getData = form?.getFieldValue([
                                  "batches",
                                  name,
                                ]);
                                console.log("getData", getData);

                                const bNo = getData?.batchNumber;

                                const addedBatch = props?.addBatches?.filter(
                                  (batchItm: any) =>
                                    !bNo.includes(batchItm?.batchNumber)
                                );
                                setAddBatchNo(addedBatch);
                                console.log("addedBatch", addedBatch);
                                console.log("bNo", bNo);
                                remove(name);
                              }}
                              type="text"
                              size="small"
                              disabled={
                                props?.alReadySelectedData?.batchItem?.length ||
                                fields.length === 1
                                  ? true
                                  : false
                              }
                            >
                              <DeleteOutlined style={{ color: "red" }} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                      {/* <Row gutter={15} style={{ marginTop: "10px" }}>
                      <Col>
                        <Button
                          type="primary"
                          size="small"
                          icon={<PlusOutlined />}
                          onClick={() => add(fields.length + 1)}
                        >
                          Add
                        </Button>
                      </Col>
                    </Row> */}
                    </>
                  )}
                </Form.List>
              </tbody>
            </table>
          </Form>
        </Spin>

        {props?.alReadySelectedData?.batchItem?.length ? (
          <></>
        ) : (
          <>
            {location.pathname.split("/")[4] === "purchase" && (
              <>
                <Divider style={{ margin: "50px 0px 15px 0px" }} />
                <h3 style={{ marginBottom: "10px" }}>Add Batch</h3>
                <Row gutter={15}>
                  <Col span={7}>
                    <Form.Item
                      label="Enter Batch No."
                      className="m-0"
                      validateTrigger="onChange"
                      rules={[
                        {
                          pattern: /^[a-zA-Z0-9]*$/,
                          message: "Special characters are not allowed!",
                        },
                      ]}
                    >
                      <Input
                        // style={{ width: "300px" }}
                        value={searchVal}
                        maxLength={20}
                        onChange={(e) => {
                          setSearchVal(e.target.value);
                        }}
                        className="input"
                        // addonAfter={
                        //   <>
                        //     <Button
                        //       onClick={handleAddBatchNumber}
                        //       size="small"
                        //       loading={btnLoading}
                        //       style={{
                        //         cursor: "pointer",
                        //         border: "none",
                        //       }}
                        //     >
                        //       <PlusOutlined />
                        //     </Button>
                        //   </>
                        // }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form form={form3}>
                      <Form.Item
                        name="pPrice"
                        label="Purchase Price"
                        className="m-0"
                        rules={[
                          {
                            pattern: /^\d+$/,
                            message: "Only numbers are allowed!",
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "100%" }}
                          value={purchasePrice}
                          onChange={(e) => {
                            setPurchasePrice(e.target.value);
                          }}
                          className="input"
                          maxLength={11}
                          //type="number"

                          max={99999999999}

                          // addonAfter={
                          //   <>
                          // <Button
                          //   onClick={handleAddBatchNumber}
                          //   size="small"
                          //   loading={btnLoading}
                          //   style={{
                          //     cursor: "pointer",
                          //     border: "none",
                          //   }}
                          // >
                          //   <PlusOutlined />
                          // </Button>
                          //   </>
                          // }
                        />
                      </Form.Item>
                    </Form>
                  </Col>
                  <Col>
                    <Button
                      type="primary"
                      onClick={handleAddBatchNumber}
                      loading={btnLoading}
                      size="small"
                      style={{
                        padding: "13px 15px",
                      }}
                    >
                      <PlusOutlined /> Add
                    </Button>
                  </Col>
                </Row>

                {formTwoData?.length > 0 && (
                  <div style={{ maxHeight: "50ch", overflowY: "scroll" }}>
                    <Form
                      form={form2}
                      // initialValues={{
                      //   batches2: [{}],
                      // }}
                      onValuesChange={secFormVal}
                    >
                      <table
                        className="AddPageTabelDesign"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          <tr>
                            <th>Batch No.</th>
                            <th>Mgf. Date</th>
                            <th>Expiry Date</th>
                            {location.pathname.split("/")[4] === "sales" ||
                            location.pathname.split("/")[4] === "purchase" ? (
                              <>
                                <th>Quantity</th>
                              </>
                            ) : (
                              <>
                                <th>Opening Qty.</th>
                              </>
                            )}
                            {location.pathname.split("/")[4] === "sales" ? (
                              <></>
                            ) : (
                              <th>Purchase Price</th>
                            )}
                            {location.pathname.split("/")[4] === "sales" ? (
                              ""
                            ) : (
                              <th>
                                Sales Price
                                <Tooltip placement="top" title={text}>
                                  <QuestionOutlined
                                    style={{ marginLeft: "4px" }}
                                  />
                                </Tooltip>
                              </th>
                            )}

                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          <Form.List name="batches2">
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map((field, name, index: any) => (
                                  <tr key={field.key}>
                                    <td style={{ width: "15%" }}>
                                      <Form.Item
                                        name={[name, "batchNumber"]}
                                        className="m-0"
                                        // rules={[
                                        //   ({ getFieldValue }) => ({
                                        //     validator(_, value) {
                                        //       const openingQty = getFieldValue([
                                        //         "batches",
                                        //         name,
                                        //         "openingQuantity",
                                        //       ]);
                                        //       if (openingQty && !value) {
                                        //         return Promise.reject(
                                        //           new Error(
                                        //             "Batch No. is required if Opening Qty is entered"
                                        //           )
                                        //         );
                                        //       }
                                        //       return Promise.resolve();
                                        //     },
                                        //   }),
                                        //   {
                                        //     required: true,
                                        //     message: "Please input your Batch No.!",
                                        //   },
                                        // ]}
                                      >
                                        <Input
                                          placeholder="Batch No."
                                          disabled={true}
                                        />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      <Form.Item
                                        name={[name, "mfDate"]}
                                        className="m-0"
                                      >
                                        <DatePicker
                                          placeholder="MFD. Date"
                                          format={"DD/MM/YYYY"}
                                          style={{ width: "100%" }}
                                        />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: "10%" }}>
                                      <Form.Item
                                        name={[name, "expiryDate"]}
                                        className="m-0"
                                        dependencies={[
                                          ["batches2", name, "mfDate"],
                                        ]}
                                      >
                                        <DatePicker
                                          placeholder="Expiry Date"
                                          format="DD/MM/YYYY"
                                          style={{ width: "100%" }}
                                          disabledDate={(current) =>
                                            current <
                                            form
                                              .getFieldValue([
                                                "batches2",
                                                name,
                                                "mfDate",
                                              ])
                                              ?.startOf("day")
                                          }
                                        />
                                      </Form.Item>
                                    </td>
                                    {location.pathname.split("/")[4] ===
                                      "sales" ||
                                    location.pathname.split("/")[4] ===
                                      "purchase" ? (
                                      <>
                                        <td style={{ width: "10%" }}>
                                          <Form.Item
                                            name={[name, "qty"]}
                                            className="m-0"
                                            rules={[
                                              {
                                                validator: (_: any, value) =>
                                                  value > 0
                                                    ? Promise.resolve()
                                                    : Promise.reject(
                                                        "Quantity must be greater than 0!"
                                                      ),
                                              },
                                              {
                                                pattern: /^\d+$/,
                                                message:
                                                  "Only numbers are allowed",
                                              },
                                            ]}
                                          >
                                            <InputNumber
                                              // min={0}
                                              placeholder="Qty."
                                              style={{ width: "100%" }}
                                              // type="number"
                                              maxLength={11}
                                            />
                                          </Form.Item>
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td style={{ width: "10%" }}>
                                          <Form.Item
                                            name={[name, "openingQuantity"]}
                                            className="m-0"
                                          >
                                            <InputNumber
                                              min={0}
                                              placeholder="Opening Qty."
                                              style={{ width: "100%" }}
                                            />
                                          </Form.Item>
                                        </td>
                                      </>
                                    )}

                                    {location.pathname.split("/")[4] ===
                                    "sales" ? (
                                      <></>
                                    ) : (
                                      <td style={{ width: "12%" }}>
                                        <Form.Item
                                          name={[name, "purchasePrice"]}
                                          className="m-0"
                                          // rules={[
                                          //   {
                                          //     validator: (_: any, value) =>
                                          //       value > 0
                                          //         ? Promise.resolve()
                                          //         : Promise.reject(
                                          //             "Purchase price must be greater than 0!"
                                          //           ),
                                          //   },
                                          // ]}

                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "Please enter purchase price",
                                            },
                                            {
                                              validator: (_, value) => {
                                                const currentList =
                                                  form2.getFieldValue(
                                                    "batches2"
                                                  ) || [];
                                                const currentItem =
                                                  currentList[name];

                                                const { batchNumber } =
                                                  currentItem || {};

                                                console.log(
                                                  "currentList",
                                                  currentList.filter(
                                                    (e: any, i: any) =>
                                                      i !== name
                                                  )
                                                );
                                                const allVal = [
                                                  ...currentList,
                                                  ...batchData,
                                                ];
                                                console.log("allVal", allVal);

                                                const isDuplicate = allVal
                                                  .filter(
                                                    (e: any, i: any) =>
                                                      i !== name
                                                  )
                                                  .some(
                                                    (
                                                      item: any,
                                                      idx: number
                                                    ) => {
                                                      return (
                                                        item?.batchNumber ===
                                                          batchNumber &&
                                                        item?.purchasePrice ==
                                                          value
                                                      );
                                                    }
                                                  );
                                                console.log(
                                                  "isDuplicate",
                                                  isDuplicate
                                                );

                                                if (isDuplicate) {
                                                  return Promise.reject(
                                                    new Error(
                                                      "Same Batch Number already exists with this Purchase Price"
                                                    )
                                                  );
                                                }

                                                return Promise.resolve();
                                              },
                                            },
                                          ]}
                                        >
                                          <InputNumber
                                            min={0}
                                            placeholder="Purchase Price"
                                            style={{ width: "100%" }}
                                            maxLength={11}
                                            onChange={(e: any) => {
                                              const getVal = form2
                                                .getFieldValue(["batches2"])
                                                ?.some(
                                                  (item: any) =>
                                                    item.batchNumber
                                                );
                                              console.log("getVal", getVal);

                                              if (getVal === e) {
                                                return Promise.reject(
                                                  new Error("make proper")
                                                );
                                              }
                                            }}
                                          />
                                        </Form.Item>
                                      </td>
                                    )}
                                    {location.pathname.split("/")[4] ===
                                    "sales" ? (
                                      <></>
                                    ) : (
                                      <td style={{ width: "10%" }}>
                                        <Form.Item
                                          name={[name, "salesPrice"]}
                                          className="m-0"
                                        >
                                          <InputNumber
                                            min={0}
                                            placeholder="Sales Price"
                                            style={{ width: "100%" }}
                                            maxLength={11}
                                          />
                                        </Form.Item>
                                      </td>
                                    )}
                                    {/* {location.pathname.split("/")[4] === "sales" ||
                          location.pathname.split("/")[4] === "purchase" ? (
                            <></>
                          ) : (
                            <td style={{ width: "10%" }}>
                              <Form.Item
                                name={[name, "status"]}
                                className="m-0"
                              >
                                <Select
                                  style={{ width: "100%" }}
                                  options={[
                                    {
                                      value: BatchItemStatus.Available,
                                      label: "Available",
                                    },
                                    {
                                      value: BatchItemStatus.Sold,
                                      label: "Sold",
                                    },
                                    {
                                      value: BatchItemStatus.Expired,
                                      label: "Expired",
                                    },
                                    {
                                      value: BatchItemStatus.Damaged,
                                      label: "Damaged",
                                    },
                                    {
                                      value: BatchItemStatus.Returned,
                                      label: "Returned",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </td>
                          )} */}
                                    <td align="center" style={{ width: "3%" }}>
                                      <Button
                                        type="text"
                                        danger
                                        icon={<DeleteOutlined />}
                                        onClick={() => {
                                          remove(field.name);
                                          handleDeleteBatch(index);
                                        }}
                                      />
                                    </td>
                                  </tr>
                                ))}
                                {/* <Row gutter={15} style={{ marginTop: "10px" }}>
                              <Col>
                                <Button
                                  type="primary"
                                  size="small"
                                  icon={<PlusOutlined />}
                                  onClick={() => add(fields.length + 1)}
                                >
                                  Add
                                </Button>
                              </Col>
                            </Row> */}
                              </>
                            )}
                          </Form.List>
                        </tbody>
                      </table>
                    </Form>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </Modal>
    </>
  );
};

export default SelectBatchItemModal;
